// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"1dd9b80a","758":"c97f02f1"}[chunkId] + ".chunk.css";
};